<div class="container">
  <div class="marketing-title-box">
    <div>
      <div class="headerText">Dashboard</div>
      <div class="subText">
        <a [routerLink]="['/']"><fa-icon icon="home"></fa-icon></a> / Dashboard
      </div>
    </div>

    @if (banner) {
      <a [href]="banner.action_url" target="_blank" (click)="onBannerClick()" class="banner-a">
        <img class="marketing-image" [src]="banner.banner_image" [alt]="banner.alt_text" [matTooltip]="banner.tool_tip" />
      </a>
    }

  </div>

  @for (notification of notifications; track $index) {
    <div class="{{getClassStringForNotificationType(notification.type)}}">
      <div class="icon__wrapper">
        <mat-icon>{{notification.type.toLowerCase()}}</mat-icon>
      </div>
      <p>{{notification.text}}</p>
    </div>
  }

  <div class="grid-container">
    <mat-grid-list cols="2" rowHeight="380px">
      @for (card of cards | async; track $index) {
        <mat-grid-tile
          [colspan]="card.cols"
          [rowspan]="card.rows"
          >
          @if (card.title == recentsTitle) {
            <mat-card appearance="outlined" class="dashboard-card">
              @if (card.title == recentsTitle) {
                <mat-tab-group
                  color="accent"
                  backgroundColor="primary"
                  class="dashboard-card-recents"
                  [selectedIndex]="0"
                  (selectedTabChange)="onRecentTabChange($event)"
                  >
                  <mat-tab #recentTab>
                    <ng-template mat-tab-label>
                      <span class="{{recentTab.isActive ? 'selected-tab-label':'tab-label'}}">Recent Comments</span>
                    </ng-template>
                    <div class="row">
                      <div class="col">
                        <div class="panel-body">
                          @for (comment of recent_comments; track $index) {
                            <mat-card appearance="outlined" class="results-card">
                              <mat-card-header class="card_header">
                                <div mat-card-avatar class="header-icon">
                                  <fa-icon icon="comment-dollar"></fa-icon>
                                </div>
                                <mat-card-title>{{ comment.client_name }}</mat-card-title>
                                <mat-card-subtitle>{{ comment.first_name }} {{ comment.last_name }}</mat-card-subtitle>
                              </mat-card-header>
                              <img
                                mat-card-image
                                class="thumbnail"
                                src="{{ comment.thumbnail_url }}"
                                alt="SalesMail"
                                onerror="if (this.src != '/assets/images/image_not_available.png') { this.src = '/assets/images/image_not_available.png'; }"
                                />
                              <mat-card-content class="title-text">
                                <p class="recents-comment">{{ comment.comment }}</p>
                                <p class="comment-meta">{{ comment.from_name }} - {{ comment.email }}</p>
                                <p class="date">{{ comment.cre_date | date: "medium" }}</p>
                              </mat-card-content>
                              <mat-card-actions class="details-button-comments">
                                <button
                                  mat-stroked-button
                                  color="primary"
                                  (click)="viewDetails(comment, 'dashboard_comment_detail_click')"
                                  >
                                  Details
                                </button>
                              </mat-card-actions>
                            </mat-card>
                          }
                          <div class="info-link">
                            <a
                              mat-button
                              color="primary"
                              href="https://support.heartlegacy.com/portal/en/kb/articles/how-to-get-more-engagement-on-your-salesmail-videos"
                              target="_blank"
                              >
                              How to get more Comments
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab #ctaTab>
                    <ng-template mat-tab-label>
                      <span class="{{ctaTab.isActive ? 'selected-tab-label':'tab-label'}}">Recent CTA Clicks</span>
                    </ng-template>
                    <mat-card appearance="outlined">
                      <div class="row">
                        <div class="col">
                          <div class="panel-body">
                            @for (cta of recent_cta; track $index) {
                              <mat-card
                                appearance="outlined"
                                class="results-card"
                                >
                                <mat-card-header class="card_header">
                                  <div mat-card-avatar class="header-icon">
                                    <fa-icon icon="bullhorn"></fa-icon>
                                  </div>
                                  <mat-card-title>{{ cta.cta_display }}</mat-card-title>
                                  <mat-card-subtitle>{{ cta.cta_url }}</mat-card-subtitle>
                                </mat-card-header>
                                <img
                                  mat-card-image
                                  class="thumbnail"
                                  src="{{ cta.thumbnail_url }}"
                                  alt="SalesMail"
                                  onerror="if (this.src != '/assets/images/image_not_available.png') { this.src = '/assets/images/image_not_available.png'; }"
                                  />
                                <mat-card-content class="title-text">
                                  <p>Full Video Length: {{ cta.video_length }}</p>
                                  <p>Time On Page Till Click: {{ cta.time_till_click }}</p>
                                  <p class="date">{{ cta.cre_date | date: "medium" }}</p>
                                </mat-card-content>
                                <mat-card-actions class="details-button-comments">
                                  <button
                                    mat-stroked-button
                                    color="primary"
                                    (click)="viewDetails(cta, 'dashbord_cta_detail_click')"
                                    >
                                    Details
                                  </button>
                                </mat-card-actions>
                              </mat-card>
                            }
                            <div class="info-link">
                              <a
                                mat-button
                                color="primary"
                                href="https://support.heartlegacy.com/portal/en/kb/articles/how-to-get-more-engagement-on-your-salesmail-videos"
                                target="_blank"
                                >
                                How to get more Call To Action (CTA) Clicks
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-card>
                  </mat-tab>
                  <mat-tab #recationTab>
                    <ng-template mat-tab-label>
                      <span class="{{recationTab.isActive ? 'selected-tab-label':'tab-label'}}">Recent Reactions</span>
                    </ng-template>
                    <mat-card appearance="outlined">
                      <div class="row">
                        <div class="col">
                          <div class="panel-body">
                            @for (r of recent_reactions; track $index) {
                              <mat-card
                                appearance="outlined"
                                class="results-card"
                                >
                                <mat-card-header class="card_header">
                                  <div mat-card-avatar class="header-icon">
                                    <fa-icon icon="{{ r.reaction | smReaction }}"></fa-icon>
                                  </div>
                                  <mat-card-title>{{ r.reaction }}</mat-card-title>
                                  <mat-card-subtitle>{{ r.cre_date | date: "medium" }}</mat-card-subtitle>
                                </mat-card-header>
                                <img
                                  mat-card-image
                                  class="thumbnail"
                                  src="{{ r.thumbnail_url }}"
                                  alt="SalesMail"
                                  onerror="if (this.src != '/assets/images/image_not_available.png') { this.src = '/assets/images/image_not_available.png'; }"
                                  />
                                <mat-card-actions>
                                  <button
                                    class="details-button"
                                    mat-stroked-button
                                    color="primary"
                                    (click)="viewDetails(r, 'dashboard_reaction_detail_click')"
                                    >
                                    Details
                                  </button>
                                </mat-card-actions>
                              </mat-card>
                            }
                            <div class="info-link">
                              <a
                                mat-button
                                color="primary"
                                href="https://support.heartlegacy.com/portal/en/kb/articles/how-to-get-more-engagement-on-your-salesmail-videos"
                                target="_blank"
                                >
                                How to get more Reactions
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-card>
                  </mat-tab>
                </mat-tab-group>
              }
            </mat-card>
          }
          @if (card.title != recentsTitle) {
            <mat-card appearance="outlined" class="dashboard-card">
              <div class="card-header">
                <div class="card-title">
                  @if (card.title == opensTitle) {
                    <div>                      
                      <div class="dashboard-menu-button-container">
                        {{ card.title }}
                        <button mat-flat-button class="dashboard-menu-button" [matMenuTriggerFor]="menu" aria-label="Toggle menu">
                          <div class="dashboard-inner-menu-button-container">
                            <div class="dashboard-menu-button-left"></div>
                            <div class="dashboard-menu-button-center">
                              {{ opensAndViewsDays }} Day
                            </div>
                            <div class="dashboard-menu-button-right">
                              <mat-icon>expand_more</mat-icon>
                            </div>
                          </div>
                        </button>
                        <mat-menu #menu="matMenu" xPosition="before">
                          <button mat-menu-item (click)="getOpenAndViewsData(30)">
                            30 Day
                          </button>
                          <button mat-menu-item (click)="getOpenAndViewsData(60)">
                            60 Day
                          </button>
                          <button mat-menu-item (click)="getOpenAndViewsData(90)">
                            90 Day
                          </button>
                        </mat-menu>
                      </div>
                    </div>
                  }
                  @if (card.title == usersTitle) {
                    <div>
                      <div class="dashboard-menu-button-container">
                        {{ card.title }}
                        <button mat-flat-button class="dashboard-menu-button" [matMenuTriggerFor]="menu" aria-label="Toggle menu">
                          <div class="dashboard-inner-menu-button-container">
                            <div class="dashboard-menu-button-left"></div>
                            <div class="dashboard-menu-button-center">
                              {{ topSenderDays }} Day
                            </div>
                            <div class="dashboard-menu-button-right">
                              <mat-icon>expand_more</mat-icon>
                            </div>
                          </div>
                        </button>
                        <mat-menu #menu="matMenu" xPosition="before">
                          <button mat-menu-item (click)="topSendersChange(30)">
                            30 Day
                          </button>
                          <button mat-menu-item (click)="topSendersChange(60)">
                            60 Day
                          </button>
                          <button mat-menu-item (click)="topSendersChange(90)">
                            90 Day
                          </button>
                        </mat-menu>
                      </div>                      
                    </div>
                  }
                  @if (card.title == teamResults) {
                    <div>
                      <div class="dashboard-menu-button-container">
                        {{ card.title }}
                        <button mat-flat-button class="dashboard-menu-button" [matMenuTriggerFor]="menu" aria-label="Toggle menu">
                          <div class="dashboard-inner-menu-button-container">
                            <div class="dashboard-menu-button-left"></div>
                            <div class="dashboard-menu-button-center">
                              {{ teamResultsDays }} Day
                            </div>
                            <div class="dashboard-menu-button-right">
                              <mat-icon>expand_more</mat-icon>
                            </div>
                          </div>
                        </button>
                        <mat-menu #menu="matMenu" xPosition="before">
                          <button mat-menu-item (click)="teamDaysChange(30)">
                            30 Day
                          </button>
                          <button mat-menu-item (click)="teamDaysChange(60)">
                            60 Day
                          </button>
                          <button mat-menu-item (click)="teamDaysChange(90)">
                            90 Day
                          </button>
                        </mat-menu>
                      </div>                      
                    </div>
                  }
                  @if (card.title == usageTitle) {
                    <div>
                      <div class="dashboard-menu-button-container">
                        {{ card.title }}
                        <button mat-flat-button class="dashboard-menu-button" [matMenuTriggerFor]="menu" aria-label="Toggle menu">
                          <div class="dashboard-inner-menu-button-container">
                            <div class="dashboard-menu-button-left"></div>
                            <div class="dashboard-menu-button-center">
                              {{ usageDays }} Day
                            </div>
                            <div class="dashboard-menu-button-right">
                              <mat-icon>expand_more</mat-icon>
                            </div>
                          </div>
                        </button>
                        <mat-menu #menu="matMenu" xPosition="before">
                          <button mat-menu-item (click)="usageDaysChange(30)">30 Day</button>
                          <button mat-menu-item (click)="usageDaysChange(60)">60 Day</button>
                          <button mat-menu-item (click)="usageDaysChange(90)">90 Day</button>
                        </mat-menu>
                      </div>                      
                    </div>
                  }
                  @if (card.title == leaderboardTitle) {
                    <div>
                      <div class="dashboard-menu-button-container">
                        <div>
                          {{ card.title }}
                          <a mat-button class="lb-info-button" href="https://support.heartlegacy.com/portal/en/kb/articles/salesmail-leaderboard" target="_blank" (click)="didClickLbInfo()" matTooltip="Click here to learn about the SalesMail Leaderboard!" >
                            <mat-icon class="white_text">info</mat-icon>
                          </a>
                        </div>
                        <button mat-flat-button class="dashboard-menu-button" [matMenuTriggerFor]="menu" aria-label="Toggle menu">
                          <div class="dashboard-inner-menu-button-container">
                            <div class="dashboard-menu-button-left"></div>
                            <div class="dashboard-menu-button-center">
                              {{ getButtonTextforLbType() }}
                            </div>
                            <div class="dashboard-menu-button-right">
                              <mat-icon>expand_more</mat-icon>
                            </div>
                          </div>
                        </button>
                        <mat-menu #menu="matMenu" xPosition="before">
                          <button mat-menu-item (click)="changeLeaderboardType('tes')">Top Score</button>
                          <button mat-menu-item (click)="changeLeaderboardType('views')">Top Views</button>
                          <button mat-menu-item (click)="changeLeaderboardType('videos')">Top Videos</button>
                        </mat-menu>
                      </div>                       
                    </div>
                  }
                  @if (card.title == rankTitle) {
                    <div>
                      {{card.title}}
                      <a mat-button class="lb-info-button" href="https://support.heartlegacy.com/portal/en/kb/articles/achievements-salesmail-rank-panel" target="_blank" (click)="didClickRankInfo()" matTooltip="Click here to learn about the SalesMail Rank!" >
                        <mat-icon class="white_text">info</mat-icon>
                      </a>
                    </div>
                  }
                </div>
              </div>
              <mat-card-content
                [ngClass]="{ 'dashboard-padding-fix': card.title == opensTitle }"
                class="dashboard-card-content"
                >
                @if (card.title == opensTitle) {
                  <div>
                    <chart-opens-views
                      [isLoading]="opensAndViewsLoading"
                      [opensAndViewsData]="opensAndViewsData"
                      [opensAndViewsError]="opensAndViewsError"
                      [days]="opensAndViewsDays"
                    ></chart-opens-views>
                  </div>
                }
                @if (card.title == usersTitle) {
                  <div class="full-height">
                    <chart-top-senders
                      [topSenderData]="topSenderData"
                      [topSenderError]="topSenderError"
                      [isLoading]="topSendersLoading"
                    ></chart-top-senders>
                  </div>
                }
                @if (card.title == teamResults) {
                  <div>
                    <dashboard-team-results [days]="teamResultsDays"></dashboard-team-results>
                  </div>
                }
                @if (card.title == leaderboardTitle) {
                  <div class="full-height">
                    <app-leaderboard [dashboardLbType]="leaderboardType"></app-leaderboard>
                  </div>
                }
                @if (card.title == usageTitle) {
                  <div>
                    <chart-users-usage [days]="usageDays"></chart-users-usage>
                  </div>
                }
                @if (card.title == rankTitle) {
                  <div class="full-height">
                    <app-rank></app-rank>
                  </div>
                }
              </mat-card-content>
            </mat-card>
          }
        </mat-grid-tile>
      }
    </mat-grid-list>
  </div>
</div>
